import { BoxV2 as Box, Flex, Tooltip } from 'portal-commons';
import { FunctionComponent } from 'react';
import { TableCell, TableRow } from '@material-ui/core';

import { BillingCategory } from '@/apis/core';

interface BillingCategoryRowProps {
  checked: boolean;
  option: BillingCategory;
  onChange: (value: string) => void;
}

const BillingCategoryRow: FunctionComponent<BillingCategoryRowProps> = ({
  checked,
  option,
  onChange,
  ...props
}) => (
  <TableRow {...props}>
    <TableCell>
      <Tooltip title={option.description}>
        <Flex
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: '7px',
            width: 'fit-content',
            cursor: 'pointer',
          }}
          onClick={() => onChange(option.id)}
        >
          <input
            style={{ accentColor: '#333E41', cursor: 'pointer' }}
            type="radio"
            name="billingCategory"
            readOnly
            checked={checked}
          />
          <Box sx={{ fontWeight: 400, fontSize: 'H200', color: 't.black80' }}>
            {option.name}
          </Box>
        </Flex>
      </Tooltip>
    </TableCell>
  </TableRow>
);

export default BillingCategoryRow;
